export default __webpack_public_path__ + "static/media/hiq.40dd87a4.png";